<template>
  <!-- <v-dialog v-model="show" hide-overlay transition="dialog-bottom-transition"> -->
  <v-form ref="form" v-model="valid" :lazy-validation="lazy">
    <v-card v-model="show">
      <v-toolbar dark color="blue">
        <!-- <v-btn icon dark @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn> -->
        <v-toolbar-title
          >Recepción de Materiales Sin Documentación</v-toolbar-title
        >
      </v-toolbar>
      <v-card-text>
        <v-row dense>
          <!-- <v-col cols="12" sm="6" md="6">
            <v-text-field
              requiered
              :rules="requiredRules"
              label="Referencia"
              dense
              v-model="referencia"
            >
            </v-text-field>
          </v-col> -->
          <v-col cols="12" sm="6" md="6">
            <v-select
              v-model="select"
              :items="obras"
              item-text="nombre"
              item-value="codigo"
              label="Obras"
              return-object
              single-line
              menu-props="auto"
              hide-details
              required
              :rules="requiredRules"
              dense
            ></v-select>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="4" md="4">
            <v-text-field
              requiered
              :rules="requiredRules"
              label="Recepcionó"
              dense
              v-model="recepciono"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-text-field
              required
              :rules="requiredRules"
              label="Fecha"
              dense
              v-model="fecha"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-text-field
              requiered
              :rules="requiredRules"
              label="Lugar"
              dense
              v-model="lugar"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="4" md="4">
            <v-text-field
              required
              :rules="requiredRules"
              label="Transporte"
              dense
              v-model="transporte"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-text-field
              required
              :rules="requiredRules"
              label="Remito"
              dense
              v-model="numremito"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-text-field
              required
              :rules="requiredRules"
              label="Proveedor"
              dense
              v-model="prove"
            >
            </v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="materiales"
        locale="es-ar"
        class="elevation-1"
        :items-per-page="10"
        :footer-props="{
          itemsPerPageText: 'Tareas por página',
        }"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title
              >Completar materiales recibidos sin documentación</v-toolbar-title
            >
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  Agregar Material
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          autofocus
                          v-model="editedItem.detalle"
                          label="Detalle"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          v-model="editedItem.cantidad"
                          label="Cantidad"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          v-model="editedItem.unidad"
                          label="Unidad"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">
                    Cancelar
                  </v-btn>
                  <v-btn color="blue darken-1" text @click="save">
                    Guardar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogDelete" max-width="500px">
              <v-card>
                <v-card-title class="headline"
                  >Está seguro que desea borrar?</v-card-title
                >
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="closeDelete"
                    >Cancel</v-btn
                  >
                  <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                    >OK</v-btn
                  >
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" color="purple" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small color="red" @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
    </v-card>

    <v-card color="blue" dark tile>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" :disabled="!valid" @click.stop="guardarremito"
          >Guardar</v-btn
        >

        <v-btn color="error" @click.stop="show = false">Salir</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
  <!-- </v-dialog> -->
</template>

<style scoped>
::v-deep .right-input input {
  text-align: right !important;
}
.v-input input {
  text-align: right !important;
}
.v-text-field__slot input {
  text-align: right;
}
</style>
<script>
import moment from "moment";
import axios from "../../../src/axios-auth";
export default {
  data: (vm) => ({
    usuario: "",
    valid: true,
    lazy: true,
    mostrar: false,
    requiredRules: [(v) => !!v || "Dato obligatorio"],
    materiales: [],
    recepciono: "",
    lugar: "",
    referencia: "",
    select: "",
    obras: [],
    numremito: "",
    prove: "",
    fecha: moment().format("DD/MM/YYYY"),
    transporte: "",
    recepcionmat: [],
    dialog: false,
    dialogDelete: false,
    headers: [
      { text: "Detalle", value: "detalle", width: "50%", sortable: false },
      { text: "Cantidad", value: "cantidad", sortable: false },
      { text: "Unidad", value: "unidad", sortable: false },
      { text: "Acciones", value: "actions", sortable: false },
    ],
    editedIndex: -1,
    editedItem: {
      detalle: "",
      cantidad: "",
      unidad: "",
    },
    defaultItem: {
      detalle: "",
      cantidad: "",
      unidad: "",
    },
  }),

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Material" : "Editar Material";
    },
    show: {
      get() {
        this.cargarObras();
        this.mostrar = true;
        this.recepciono = this.$store.state.nombre.toString().trim();
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.vaciarListado();
          this.$refs.form.resetValidation();
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.$emit("close");
        }
      },
    },
  },
  methods: {
    cargarObras() {
      let self = this;
      axios
        .get("/Obras/GetObrasPA", {
          params: {
            estado: "P",
            filtro: "",
          },
        })
        .then((response) => {
          self.obras = response.data;
          self.responsable = self.$store.state.nombre.toString().trim();
        })
        .catch((error) => {
          self.obras = [];
        });
    },
    editItem(item) {
      this.editedIndex = this.materiales.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.materiales.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.materiales.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.materiales[this.editedIndex], this.editedItem);
      } else {
        this.materiales.push(this.editedItem);
      }
      this.close();
    },

    vaciarListado() {
      this.materiales = [];
      this.prove = "";
      this.lugar = "";
      this.transporte = "";
      this.recepciono = "";
      (this.numremito = ""), (this.referencia = ""), (this.recepcionmat = []);
    },

    guardarremito() {
      this.$swal({
        title: "Guardar Remito",
        text: "¿Desea guardar los datos del Remito?",
        icon: "success",
        type: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          this.materiales.forEach((element) => {
            if (element.recepcion != "" && element.cantidad != null) {
              this.recepcionmat.push({
                // otrabajo: element.otrabajo,
                // otrabajo: this.numot,
                //item: element.item,
                descr: element.detalle,
                cantidad: element.cantidad,
                unidad: element.unidad,
              });
            }
          });

          var datosRemito = {
            fecha: this.fecha,
            recepciono: this.recepciono,
            lugar: this.lugar,
            proveedor: this.prove,
            remito: this.numremito,
            transporte: this.transporte,
            //referencia: this.referencia,
            referencia: this.select.nombre,
            materiales: this.recepcionmat,
          };

          let self = this;
          axios
            .post("/Obras/GuardarRemitoSindoc", datosRemito)
            .then((response) => {
              self.$refs.form.resetValidation();
              self.vaciarListado();
              self.showAlert({
                icon: "success",
                title: "Remito guardado con éxito",
                vm: self,
              });
              self.$emit("close");
            })
            .catch({});
        } else {
        }
      });
    },
    showAlert(alertInfo) {
      alertInfo.vm.$swal.fire({
        icon: alertInfo.icon,
        title: alertInfo.title,
        showConfirmButton: false,
        background: "#ececec",
        timer: 2000,
      });
    },
  },
};
</script>
